module.exports = __webpack_public_path__ + "media/05-wpa-norepinephrine.edaca075.mp4";